import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SideBar from '$components/SideBar';
import { smallWidth, mobileSpacing, desktopSpacing } from '$variables/theme';

import {
  PageContainer as StyledPageContainer,
  PageWrapper,
  ContentContainer,
} from './PageContainer.styled';

const PageContainer = ({ children, withSideBar, testId, rerenderBy }) => {
  const [paddingTop, setPaddingTop] = useState(0);

  const handleResize = () => {
    const contexBarHeight = document.getElementById('context-bar')
      ? document.getElementById('context-bar').clientHeight
      : 0;

    const additionalPadding =
      window.innerWidth > smallWidth ? desktopSpacing : mobileSpacing;

    setPaddingTop(contexBarHeight + additionalPadding);
  };

  useLayoutEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [rerenderBy]);

  return (
    <>
      {withSideBar && <SideBar />}
      <ContentContainer>
        <PageWrapper data-testid={testId}>
          <StyledPageContainer
            data-testid="page-container"
            paddingTop={paddingTop}
          >
            {children}
          </StyledPageContainer>
        </PageWrapper>
      </ContentContainer>
    </>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  withSideBar: PropTypes.bool,
  testId: PropTypes.string,
  rerenderBy: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

PageContainer.defaultProps = {
  withSideBar: false,
  testId: undefined,
  rerenderBy: undefined,
};

export default PageContainer;
